import { appColors, CareerCategory } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

import { View, Text, StyleSheet } from '@react-pdf/renderer';

import { CareerCategoryGroupPDF } from '../atoms/CareerCategoryGroupPDF';
import { getCareerPathFitColor } from '../util/results.util';

const SUGGESTED_CAREER_PATH_STRINGS = appStrings.modules.results;

type SuggestedCareerPathsPDFProps = Readonly<{
  careerPathSuggestions: CareerPathWithScore[];
  careerPathCategories: CareerCategory[];
}>;

export const SuggestedCareerPathsPDF = ({
  careerPathSuggestions,
  careerPathCategories,
}: SuggestedCareerPathsPDFProps) => {
  return (
    <View style={styles.container}>
      <View style={styles.chipAndCircleContainer}>
        <View style={styles.chip}>
          <Text style={styles.title}>{SUGGESTED_CAREER_PATH_STRINGS.PDF.suggestedCareerPaths}</Text>
        </View>
        <View style={styles.circlesContainer}>
          <View style={[styles.circle, { backgroundColor: getCareerPathFitColor('TOP') }]} />
          <Text style={styles.text}>{SUGGESTED_CAREER_PATH_STRINGS.suggestedFits.strong}</Text>
          <View style={[styles.circle, { backgroundColor: getCareerPathFitColor('MIDDLE') }]} />
          <Text style={styles.text}>{SUGGESTED_CAREER_PATH_STRINGS.suggestedFits.medium}</Text>
          <View style={[styles.circle, { backgroundColor: getCareerPathFitColor('LOW') }]} />
          <Text style={styles.text}>{SUGGESTED_CAREER_PATH_STRINGS.suggestedFits.low}</Text>
        </View>
      </View>

      <View style={styles.columnsContainer}>
        {careerPathCategories.map((category, index) => (
          <CareerCategoryGroupPDF
            key={index}
            index={index}
            careerPathSuggestions={careerPathSuggestions}
            category={category}
          />
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: appColors.neutral.white,
    border: `1px solid ${appColors.neutral.black}`,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 16,
    width: '100%',
  },
  title: {
    fontSize: 10,
    color: appColors.color.blue1,
    fontWeight: 'bold',
    fontFamily: 'Sarabun',
  },
  chipAndCircleContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  circlesContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  circle: {
    borderRadius: '50%',
    width: 16,
    height: 16,
  },
  text: {
    fontSize: 10,
    marginLeft: 4,
    marginRight: 12,
  },
  chip: {
    backgroundColor: appColors.color.blue7,
    padding: 5,
    paddingHorizontal: 10,
    alignSelf: 'flex-start',
    borderRadius: 3,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  columnsContainer: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 536,
    overflow: 'hidden',
    flexWrap: 'wrap',
  },
});
